@if (isTranslationLoaded) {
  <div class="practice-detail">
    <!-- Breadcrumb Navigation and header-->
    <div class="breadcrumb-container">
      <app-practice-header
        [teamOptions]="teamOptions"
        [selectedTeams]="selectedTeams"
        [isLoadingTeams]="isLoadingTeams"
        [accountUuid]="accountUuid || ''"
        [moduleAssignmentUuid]="practiceId || ''"
        (teamChange)="onTeamChange($event)"
      >
      </app-practice-header>
    </div>
  </div>
}
<div class="practice-detail-content-wrapper">
  <qai-inner-wrap>
    <div class="practice-detail-content">
      <app-practice-statistics 
        [engagementStats]="individualAssignmentEngagementStats"
        [isLoadingEngagementStats]="isLoadingEngagementStats">
      </app-practice-statistics>
      <!-- Highlight cards -->
      <app-highlight-cards></app-highlight-cards>
      <!-- Simulations -->
      <app-practice-simulations 
        [assignmentId]="practiceId" 
        [selectedTeamIds]="selectedTeams"
        [selectedAccountUuid]="accountUuid"
        [assignmentName]="heading"
        [engagementStatus]="engagementStatus"
        >
      </app-practice-simulations>
      <!-- Users — hidden when Hide_Individual_User_Data flag is on -->
      @if (!hideIndividualUserData) {
        <div #practiceUsersSection>
          <app-practice-users
            [isUserModalOpen]="isUserModalVisible"
            (expandUserModal)="openUserModal()"
            (closeUserModal)="closeUserModal()"
            [engagementStatus]="engagementStatus"
            [assignmentName]="heading"
            [moduleAssignmentUuid]="practiceId || ''"
            [teamUuids]="selectedTeams"
            [userData]="userEngagementData"
            [isLoadingData]="isLoadingUsers"
          >
          </app-practice-users>
        </div>
      }
      <!-- Sessions — hidden when Hide_Individual_User_Data flag is on -->
      @if (!hideIndividualUserData) {
        <app-practice-sessions [selectedTeams]="selectedTeams" [moduleAssignmentUuid]="practiceId || ''" [assignmentName]="heading"></app-practice-sessions>
      }
    </div>
  </qai-inner-wrap>
</div>

@if (!hideIndividualUserData) {
  <app-practice-assignment-user-modal
    [openUserModal]="isUserModalVisible"
    [moduleAssignmentUuid]="practiceId || ''"
    [teamUuids]="selectedTeams"
    [engagementStatus]="engagementStatus"
    [userData]="userEngagementData"
    [isLoadingData]="isLoadingUsers"
    (closeUserModal)="closeUserModal()"
    [assignmentName]="heading"
  ></app-practice-assignment-user-modal>
}
